import { cloudinaryImageUrl } from "./cloudinary-url";

interface UserMetaInput {
  bio?: string;
  experiencesCount?: number;
  firstName?: string;
  imageId?: string;
  lastName?: string;
  reviewsCount?: number;
  username: string;
  wishlistedCount?: number;
}

export function getUserTitle(user: UserMetaInput, pageType?: string): string {
  const pageTitle: string[] = [];

  const pageTitlesMap: { [key: string]: string } = {
    "/badges": "badges",
    "/experiences": "experiences",
    "/reviews": "reviews",
    "/wishlist": "wishlist",
  };

  if (pageType) {
    const matchedPageType = Object.keys(pageTitlesMap).find((key) =>
      pageType.includes(key)
    );

    if (matchedPageType) {
      pageTitle.push(`@${user.username}'s ${pageTitlesMap[matchedPageType]}`);
    }
  }

  if (pageTitle.length === 0) {
    if (user.firstName) {
      pageTitle.push(user.firstName);
    }
    if (user.lastName) {
      pageTitle.push(user.lastName);
    }
    const userNameString =
      pageTitle.length > 0 ? `(@${user.username})` : `@${user.username}`;
    pageTitle.push(userNameString);
  }

  pageTitle.push("on Morty");

  return pageTitle.join(" ");
}

export function getUserDescription(user: UserMetaInput): string {
  const pageBio: string[] = [];

  if (user.bio) {
    pageBio.push(
      user.bio.trim().slice(0, 130) + (user.bio.length > 130 ? "\u2026" : "")
    );
  }
  if (user.experiencesCount) {
    pageBio.push(`${user.experiencesCount} played`);
  }
  if (user.wishlistedCount) {
    pageBio.push(`${user.wishlistedCount} wishlisted`);
  }
  if (user.reviewsCount) {
    pageBio.push(`${user.reviewsCount} reviewed`);
  }

  return pageBio.join(" \u2022 ");
}

export function getUserHeadMeta(user: UserMetaInput, pageType?: string) {
  const title = getUserTitle(user, pageType);
  const description = getUserDescription(user);

  const profileImgUrl = user.imageId ? cloudinaryImageUrl(user.imageId) : null;

  const meta: { content: string; name?: string; property?: string }[] = [
    { content: title, property: "og:title" },
    { content: description, name: "description" },
    { content: description, property: "og:description" },
  ];

  if (profileImgUrl) {
    meta.push({ content: profileImgUrl, property: "og:image" });
  }

  return [{ title }, ...meta];
}
